import React from "react";

export const LogoLCFC = React.memo(() => (
  <svg
    xmlSpace="preserve"
    id="svg504"
    viewBox="0 0 315 315"
    height="100%"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <style type="text/css" id="style294">
      {".st3{fill:#fff}.st8{fill:#164194}"}
    </style>
    <g id="Layer_1" transform="translate(-274.66 -136.16)">
      <g id="g501">
        <g id="g331">
          <defs id="defs324">
            <path id="SVGID_1_" d="M274.66 136.16h314.49v314.5H274.66z" />
          </defs>
          <clipPath id="SVGID_00000033348370182487555930000008820632101705933990_">
            <use
              xlinkHref="#SVGID_1_"
              style={{
                overflow: "visible",
              }}
              id="use326"
            />
          </clipPath>
          <path
            style={{
              fill: "#fff",
            }}
            d="M431.91 450.65c86.84 0 157.24-70.41 157.24-157.25s-70.4-157.25-157.24-157.25-157.25 70.4-157.25 157.25c0 86.84 70.4 157.25 157.25 157.25"
            clipPath="url(#SVGID_00000033348370182487555930000008820632101705933990_)"
            id="path329"
          />
        </g>
        <path
          className="st8"
          d="M431.91 445.03c83.73 0 151.63-67.88 151.63-151.63 0-83.74-67.89-151.62-151.63-151.62-83.75 0-151.63 67.89-151.63 151.62 0 83.74 67.88 151.63 151.63 151.63"
          id="path333"
        />
        <path
          className="st3"
          d="M431.91 435.27c78.34 0 141.85-63.52 141.85-141.87 0-78.34-63.51-141.86-141.85-141.86-78.35 0-141.86 63.52-141.86 141.86 0 78.35 63.51 141.87 141.86 141.87"
          id="path337"
        />
        <path
          className="st8"
          d="M293.36 293.4c0-76.51 62.03-138.53 138.54-138.54 76.51 0 138.53 62.03 138.53 138.54 0 76.51-62.03 138.55-138.53 138.55v-1.66c37.8 0 72.02-15.32 96.79-40.1 24.77-24.77 40.09-58.99 40.09-96.79 0-37.8-15.32-72.01-40.09-96.79-24.77-24.77-58.99-40.09-96.79-40.09-37.8 0-72.02 15.32-96.79 40.09-24.77 24.78-40.09 58.99-40.09 96.79 0 37.8 15.32 72.02 40.09 96.79 24.77 24.77 58.99 40.1 96.79 40.1v1.66c-76.51 0-138.53-62.04-138.54-138.55zm138.55 138.55z"
          id="path339"
        />
        <path
          className="st3"
          d="M431.91 391.8c54.34 0 98.39-44.04 98.39-98.39 0-54.33-44.05-98.39-98.39-98.39s-98.38 44.05-98.38 98.39c-.01 54.34 44.03 98.39 98.38 98.39"
          id="path341"
        />
        <path
          className="st8"
          d="M429.32 202.23c-2.06 11.15-15.43 11.13-22.87 17.05-4.26 3.44-6.46 7.56-7.56 12.26-7.03-3.58-13.85-8.86-21.15-11.75 14.46-11.15 32.65-17.63 51.58-17.56"
          id="path343"
        />
        <path
          className="st8"
          d="m484.38 218.48-17.74 11.67c-2.06-12.67-16.11-16.39-25.75-20.38-1.93-2.07-4.83-4.64-3.73-7.54 17.51.97 33.14 6.3 47.22 16.25"
          id="path345"
        />
        <path
          className="st8"
          d="M438.28 212.66c9.09 4.82 23.41 6.62 25.34 19.57-.42 1.37-2.06 1.93-2.9 2.61-.82-17.07-20.93-13.77-27.41-26.72-6.74 13.08-28.37 10.61-28.08 28.64-1.52-.68-4.28-2.33-2.76-4.95 3.71-14.47 20.93-13.51 29.19-23.42l1.25-5.24c.68 3.32 2.2 6.9 5.37 9.51"
          id="path347"
        />
        <path
          className="st8"
          d="M433.59 218.31c-.14.42.26 1.11-.27 1.38-.56.14-.69-.54-1.11-.69 0-.96 1.11-2.06 1.38-.69"
          id="path349"
        />
        <path
          className="st8"
          d="M437.16 221.61c.28.55-.27.97-.54 1.38h-.41v-2.06c.54-.14.68.41.95.68"
          id="path351"
        />
        <path
          className="st8"
          d="M430.27 221.61c-.13.42.29 1.11-.26 1.38h-.7v-1.65c.28 0 .83-.14.96.27"
          id="path353"
        />
        <path
          className="st8"
          d="M368.17 243.79c-8.68 4.95-11.08 18.66-22.1 17.55 4.68-13.22 13.07-25.48 24.36-35.39-3.15 4.97-2.67 11.78-2.26 17.84"
          id="path355"
        />
        <path
          className="st8"
          d="M434.56 236.5h-4l2.75-9.92c-.55 3.72.83 6.61 1.25 9.92"
          id="path357"
        />
        <path
          className="st8"
          d="M516.5 259.35c-9.5-.68-12.67-12.26-21.07-16.53 1.23-4.26 1.99-9.36 1.31-13.91 9.23 9.1 15.9 19.15 19.76 30.44"
          id="path359"
        />
        <path
          className="st8"
          d="m517.87 262.24.28.41c-13.22 8.96.55 29.06-13.77 37.33-4 2.76-9.11 2.76-14.33 2.62.83-3.17 5.92-1.94 8.68-3.59 16.25-4.96 7.85-24.64 16.11-35.11-8-2.21-14.33-9.23-20.8-14.46l.41-2.34c7.59 5.37 13.24 16.12 23.42 15.14"
          id="path361"
        />
        <path
          className="st8"
          d="M370.79 249.02c-6.2 7.02-12.53 14.73-21.48 16.53.96 2.62 3.3 4.67 4.26 7.29 2.89 11.16 3.17 26.58 17.48 29.75 2.07.83 4.83-.42 6.34 1.65-7.03 1.38-13.63-.27-18.46-4.96-9.92-9.64-.28-28.09-14.6-34.98 11.99 2.62 16.67-11.7 25.07-16.94z"
          id="path363"
        />
        <path
          className="st8"
          d="M498.04 262.93c-.13.41.27 1.1-.28 1.37h-.42v-2.05c.42-.14.84.28.7.68"
          id="path365"
        />
        <path
          className="st8"
          d="M369.15 264.31c.13.29-.15.41-.28.55-.69.27-.96-.27-1.37-.55-.42-1.51 2.05-1.51 1.65 0"
          id="path367"
        />
        <path
          className="st8"
          d="M495.01 267.21c-.27.27-.42.83-.96.69-.83-.42-.83-1.66 0-1.92.83-.16.69.8.96 1.23"
          id="path369"
        />
        <path
          className="st8"
          d="M501.63 265.97c0 .54.28 1.24-.28 1.64-.42.14-.68-.55-.97-.69.29-.68.29-1.23 1.25-.95"
          id="path371"
        />
        <path
          className="st8"
          d="M372.72 267.61c-.27.15-.4.69-.97.56l-.69-.56 1.11-1.38c.4.43.4.84.55 1.38"
          id="path373"
        />
        <path
          className="st8"
          d="m496.74 357.92-6.26 5.82c-1.8-13.5 13.91-22.03 10.2-36.63-1.93-7.71-10.34-13.91-17.22-16.53-.14-9.49 10.32-2.62 15.29-4.69 5.92-1.1 12.39-4.81 14.87-10.87 5.23-8.96-2.13-20.97 5.57-28.96 10.32 32.51 1.5 68.31-22.45 91.86"
          id="path375"
        />
        <path
          className="st8"
          d="M365.83 267.61c.28.56-.27.84-.69 1.25h-.27v-1.93c.4-.15.69.42.96.68"
          id="path377"
        />
        <path
          className="st8"
          d="M353.29 297.63c3.31 6.07 9.37 9.23 15.57 10.61 4.26.28 8.53-.41 12.12-.67l1.09 2.6c-7.16 2.61-14.87 8.54-16.94 16.25-3.44 14.32 9.51 23.56 11.98 36.38l-1.03 3.23c-28.54-22.69-40.94-55.74-33.92-92.21l1.82-5.91c11.86 4.94 3.4 20.78 9.31 29.72"
          id="path379"
        />
        <path
          className="st8"
          d="M500.38 283.73c-1.92-.69-2.34 1.65-3.03 2.62-.41-.82-.41-1.93-1.24-2.62l-2.05.43 3.99-12.68c-.14 4.54 1.5 8.25 2.33 12.25"
          id="path381"
        />
        <path
          className="st8"
          d="M372.17 284.41c-1.8-.4-2.48 1.11-3.02 2.35v.68c-.43-1.37-1.52-4.26-3.59-2.75 1.1-4.13 2.88-8.13 3.59-12.53-.15 4.54 1.37 8.4 3.02 12.25"
          id="path383"
        />
        <path
          className="st8"
          d="M383.74 315.55v1.24c-5.51 2.61-11.99 7.43-11.99 14.2-.82 12.51 11.15 19.53 9.92 32.07 1.92 1.52 3.72-1.24 5.92-.97 7.24-.54 27.97 1.66 32.77-4.27 1.24-.27 2.07.43 3.03.97-1.8 4-6.48 6.89-11.01 7.29-11.29 1.11-24.24-8.4-33.34 1.93 6.89-16.12-16.8-26.57-8.95-43.65 2.22-5.1 7.72-9.37 12.94-10.88z"
          id="path385"
        />
        <path
          className="st8"
          d="M497.08 329.04c1.65 14.2-14.87 21.9-10.32 36.08-13.91-7.99-32.09 11.15-43.94-5.36 0-1.1 1.25-1.94 2.07-2.34 2.48.68 3.31 3.02 5.51 4.4 10.74 7.72 22.17-2.34 33.74.56.69-1.38 0-4.13.69-5.93 4.41-10.04 15.28-22.86 4.95-33.74-2.75-2.34-5.92-4.13-9.23-5.24-.97-1.51.56-2.6.96-3.98 6.34 2.33 14.88 7.98 15.57 15.55"
          id="path387"
        />
        <path
          className="st8"
          d="M470.9 331.65c-.82.42-.82-.54-1.22-.96.4-.42.4-1.37 1.22-.96z"
          id="path389"
        />
        <path
          className="st8"
          d="M397.23 330.69c-.14.42.28 1.11-.28 1.37-.55.14-.68-.54-1.1-.67-.68-1.24 1.38-1.95 1.38-.7"
          id="path391"
        />
        <path
          className="st8"
          d="M474.63 334.69c-.41-.14-.55.14-.7.28-.41-.41-.82-1.92.29-1.92.68.26.28 1.09.41 1.64"
          id="path393"
        />
        <path
          className="st8"
          d="M400.81 334.27c.13.42-.14.55-.28.69h-.68v-1.65c.96-.41.69.7.96.96"
          id="path395"
        />
        <path
          className="st8"
          d="M393.93 334.27c-.14.55.27 1.11-.28 1.38-.55.14-.69-.41-1.11-.69-.26-.69 1.39-2.06 1.39-.69"
          id="path397"
        />
        <path
          className="st8"
          id="polygon399"
          d="M467.61 333.72v1.66h-.97v-1.66z"
        />
        <path
          className="st8"
          d="M399.58 351.21c-1.38-.97-2.89 1.38-3.04 2.35 0-1.8-2.21-2.76-3.3-2.35 2.05-3.72 2.75-8.13 3.71-12.25.41 4.27 1.51 8.26 2.63 12.25"
          id="path401"
        />
        <path
          className="st8"
          d="M473.53 351.48c-.14-.54-.82-.14-1.25-.27l-1.64 2.63c-.29-.98-.42-1.94-1.38-2.63l-1.65.27 3.29-12.52c.43 4.4 1.81 8.4 2.63 12.52"
          id="path403"
        />
        <path
          className="st8"
          d="M458.1 370.36c9.09.54 17.22-5.89 26.03-1.77-25.37 18.46-64.1 21.5-91.51 7.87l-10.6-6.27c1.79-2.61 5.85-3.68 9.3-3.81 11.29 1.78 27.81 7.57 35.67-4.97 3.73 1.8 8.82 1.1 12.25-.68 4.13 6.32 11.15 9.77 18.86 9.63"
          id="path405"
        />
        <path
          className="st3"
          d="M510.99 317.19c-5.79 0-12.39-.69-16.52-4.68-.28-1.78 1.51-2.48 2.89-2.61 5.09.96 10.33 3.17 13.63 7.29"
          id="path407"
        />
        <path
          className="st3"
          d="M368.44 313.21c.28 3.43-3.72 3.85-5.92 4.96-2.75.83-6.19 1.1-8.95.97 3.86-3.85 8.68-7.58 14.18-6.89z"
          id="path409"
        />
        <path
          className="st3"
          d="M436.21 365.12c-.14 4.27-.83 8.41-2.35 12.12-1.09-4.13-4.81-10.6-.53-14.45 1.37 0 2.47.95 2.88 2.33"
          id="path411"
        />
        <path
          className="st8"
          d="M321.61 325.35a7.9 7.9 0 0 0 1.44 3.08l-3.87-1.26a2.854 2.854 0 0 1-1.98-2.14l-2.17-9.28-5.65 1.33c-2.06.48-3.4 1.65-3.61 3.1l-2.35-10.04c.94 1.26 2.41 1.56 4.59 1.05l15.78-3.69c2.18-.5 3.33-1.41 3.65-2.98l5.37 22.96c-.43-.19-.78-.24-1.07-.17-.48.12-1.99 1.15-4.86 2.72 1.02-3.1.77-6.02 0-9.28l-1.72-7.35-6.01 1.4z"
          id="path413"
        />
        <path
          className="st8"
          d="M331.78 352.66c4.58-2.33 5.87-6.2 3.65-10.56-2.44-4.79-6.66-6.05-11.68-3.5-4.51 2.29-5.8 6.15-3.58 10.52 2.42 4.77 6.66 6.06 11.61 3.54zm-15.52-1.17c-4.19-8.24-2.16-15.13 4.71-18.63 6.99-3.55 14.27-1.12 18.34 6.9 4.19 8.25 2.29 15.11-4.95 18.8-6.65 3.37-14.03.94-18.1-7.07z"
          id="path415"
        />
        <path
          className="st8"
          d="M351.08 376.91c3.81-3.45 4.04-7.52.76-11.14-3.61-3.99-8.02-4.1-12.2-.31-3.75 3.39-3.98 7.46-.69 11.09 3.59 3.96 8.02 4.09 12.13.36zm-15.29 2.94c-6.2-6.85-6.05-14.04-.33-19.21 5.81-5.25 13.47-4.82 19.51 1.85 6.21 6.85 6.17 13.98.15 19.44-5.53 5.01-13.29 4.59-19.33-2.08z"
          id="path417"
        />
        <path
          className="st8"
          d="M359.55 396.18c.07-.11.34-.52.76-1.14l8.95-13.41-1-.67c-2.82-1.89-5.44-3.13-8.69-3.25 2.42-2.14 3.95-3.16 4.25-3.61.16-.24.21-.61.21-1.05l20.27 13.54c-.45.14-.74.35-.9.59-.28.41-.67 2.2-1.69 5.3-1.36-2.95-3.52-4.89-6.34-6.78l-1.07-.72-8.95 13.42c-1.13 1.69-1.39 3.65-.53 4.82l-8.55-5.7c1.33.24 2.66-.42 3.28-1.34z"
          id="path419"
        />
        <path
          className="st8"
          d="M395.3 401.27c3.18 1.08 4.96.72 5.66-1.32.75-2.2-.52-3.11-3.31-4.06l-6.28-2.13-1.88 5.53zm-1.7 10.55c3.26 1.1 5.27.6 5.97-1.48.69-2.04-.69-3.51-4.03-4.64l-7.38-2.5-2.07 6.08zm-13.17-4.65 5.16-15.2c.72-2.12.66-3.63-.58-4.75l13.03 4.42c7.34 2.49 10.87 5 9.31 9.6-.8 2.35-2.93 3.73-5.76 3.57 3.91 1.89 5.23 4.32 4.11 7.61-1.69 4.98-6.32 5.73-14.33 3.01l-14.29-4.85c1.62-.15 2.62-1.25 3.35-3.41z"
          id="path421"
        />
        <path
          className="st8"
          d="m426.13 412.36-4.3-11.96-5.98 11.04zm10.46 10.03-9.21-.24c.67-.61.85-1.24.92-1.98.06-.62-.05-1.22-.15-1.52l-.57-1.67-14.16-1.27-.64 1.16c-.2.35-.37.96-.43 1.58-.09.99.32 2.08.89 2.67l-9.53-2.14c1.35-1.12 2.24-1.56 3.21-3.18l10.33-17.34c.29-.48.45-.87.48-1.12.01-.16-.05-.41-.21-.89l10.2.91c-.2.4-.39.67-.41.89-.02.2.07.58.27 1.14l6.48 18.85c.62 1.79 1.48 2.84 2.53 4.15z"
          id="path423"
        />
        <path
          className="st8"
          d="m435.1 397.95 10.23-1.44c-1.36.82-1.89 2.36-1.59 4.49l2.26 16.05 6.94-.97c3.89-.56 6.82-1.76 9.15-4.26-.86 3.67-1.58 5.74-1.49 6.36.04.33.3.63.64 1l-22.7 3.19c1.35-.86 1.77-2.3 1.46-4.48l-2.26-16.05c-.31-2.22-1.11-3.44-2.64-3.89z"
          id="path425"
        />
        <path
          className="st8"
          d="m456.17 395.25 9.72-3.48c-1.16 1.07-1.37 2.69-.65 4.72l5.46 15.26 6.59-2.35c3.71-1.33 6.34-3.1 8.11-6.03-.1 3.78-.38 5.95-.17 6.53.11.31.41.56.83.86l-21.59 7.72c1.14-1.12 1.27-2.61.52-4.68l-5.46-15.27c-.74-2.12-1.78-3.15-3.36-3.28z"
          id="path427"
        />
        <path
          className="st8"
          d="M515.1 392c-1.48 1.06-3.43 3.47-6.57 5.72-7.15 5.1-13.94 4.3-18.57-2.18-4.68-6.55-3.02-14.14 4.49-19.52 3.44-2.46 6.42-3.36 7.73-4.3.34-.24.61-.58.97-.99l1.78 6.27c-2.89.09-5.35.92-7.65 2.57-4.41 3.16-5.11 7.97-2.23 11.98 3.16 4.42 7.2 5.09 11.69 1.88 2.53-1.8 4.41-4.32 6.17-7.62l3.89 5.43c-.71.22-1.25.45-1.7.76z"
          id="path429"
        />
        <path
          className="st8"
          d="m503.01 370.54 6.8-7.76c-.48 1.5.12 3.02 1.74 4.44l12.19 10.69 4.61-5.27c2.59-2.97 4.02-5.79 4.16-9.2 1.74 3.35 2.56 5.38 3.02 5.79.24.22.63.28 1.14.33l-15.11 17.24c.46-1.54-.16-2.9-1.81-4.36l-12.19-10.68c-1.69-1.47-3.09-1.88-4.55-1.22z"
          id="path431"
        />
        <path
          className="st8"
          d="M545.82 355.47c-3.97 7.19-8.72 9.1-14.49 5.91L521.6 356c-1.99-1.1-3.54-1.2-4.79-.23l4.95-8.96c-.13 1.68.74 2.78 2.76 3.9l9.55 5.27c3.12 1.73 5.85.82 7.79-2.69 1.95-3.52 1.28-6.26-1.88-8l-9.54-5.27c-1.88-1.05-3.21-1.4-4.78-.27l4.98-9c-.18 1.51.77 2.89 2.73 3.98l9.72 5.38c5.78 3.16 6.7 8.18 2.73 15.36z"
          id="path433"
        />
        <path
          className="st8"
          d="M554.46 319.11c.77-3.35.07-5.3-2.07-5.79-2.11-.48-3.43 1.04-4.22 4.48l-1.74 7.59 6.26 1.44zm-10.66-.61c.75-3.27.21-5.01-1.89-5.49-2.26-.52-3.03.83-3.7 3.7l-1.48 6.47 5.7 1.31zm7.37 14.19-15.62-3.59c-2.19-.5-3.67-.29-4.67 1.05l3.08-13.41c1.74-7.56 3.88-11.32 8.6-10.24 2.42.56 4.01 2.54 4.13 5.38 1.49-4.08 3.76-5.65 7.15-4.87 5.13 1.18 6.34 5.72 4.45 13.97l-3.38 14.7c-.31-1.61-1.52-2.48-3.74-2.99z"
          id="path435"
        />
        <path
          className="st8"
          d="m304.72 276.54 2.23-10.08c.29 1.55 1.54 2.59 3.65 3.06l15.82 3.49 1.51-6.84c.85-3.84.75-7.01-.79-10.07 3.14 2.1 4.83 3.48 5.44 3.62.32.07.69-.06 1.16-.25l-4.94 22.38c-.34-1.56-1.54-2.46-3.69-2.94l-15.83-3.49c-2.17-.47-3.6-.15-4.56 1.12z"
          id="path437"
        />
        <path
          className="st8"
          d="m331.18 253.97-14.42-7.4c-1.99-1.02-3.46-1.07-4.71-.08l11.8-23.02c.2.43.44.69.69.82.45.23 2.26.41 5.46 1.07-2.78 1.7-4.48 4.09-6 7.08l-4.48 8.74 5.12 2.63 4.95-9.66c.66-1.29.84-2.37.92-3.26l2.15 3.44c.57.89.59 1.93.09 2.93l-4.35 8.48 5.53 2.84 4.73-9.23c1.87-3.65 2.44-7.04 1.77-9.9 2.52 2.82 3.81 4.56 4.36 4.85.3.15.67.16 1.17.09L334 257.74c.11-1.57-.83-2.75-2.82-3.77z"
          id="path439"
        />
        <path
          className="st8"
          d="m336.7 214 12.63 9.89c1.79 1.41 3.26 1.76 4.7.99l-6.31 8.06c.4-1.59-.32-2.89-2.11-4.29l-12.63-9.89c-1.8-1.41-3.23-1.79-4.67-1.03l6.31-8.06c-.41 1.59.29 2.92 2.08 4.33z"
          id="path441"
        />
        <path
          className="st8"
          d="M369.9 209.26c-1.35 1.23-2.99 3.86-5.84 6.45-6.49 5.92-13.33 5.93-18.69.05-5.42-5.94-4.69-13.68 2.14-19.91 3.12-2.85 5.97-4.1 7.17-5.19.31-.28.53-.65.84-1.11l2.51 6.02c-2.86.43-5.2 1.55-7.29 3.45-4.01 3.66-4.11 8.53-.79 12.17 3.66 4.01 7.76 4.2 11.83.48 2.29-2.09 3.86-4.81 5.22-8.3l4.5 4.93c-.69.29-1.2.59-1.6.96z"
          id="path443"
        />
        <path
          className="st8"
          d="m371.72 202.85-7.6-14.32c-1.05-1.98-2.21-2.86-3.81-2.76l22.86-12.11c-.09.46-.04.82.1 1.07.24.44 1.62 1.63 3.86 4.01-3.25-.2-6.01.79-8.97 2.36l-8.68 4.6 2.69 5.09 9.6-5.08a8.454 8.454 0 0 0 2.62-2.14l-.2 4.05c-.05 1.06-.62 1.93-1.61 2.45l-8.43 4.47 2.92 5.49 9.15-4.86c3.62-1.92 6.04-4.37 7.12-7.1.44 3.76.51 5.92.8 6.47.16.29.46.51.91.74l-23.19 12.29c.99-1.24.9-2.74-.14-4.72z"
          id="path445"
        />
        <path
          className="st8"
          d="M406.01 188.44c4.02-.98 5.78-2.52 5.27-4.61-.61-2.54-3.47-2.01-8.38-1.5-6.08.63-9.5-.8-10.41-4.55-1.05-4.31 2.2-8.51 9.04-10.18 4.39-1.07 7.84-1.1 9.69-1.55.32-.08.64-.2.96-.45l-.01 6.44c-2.7-.92-6.05-1-9.79-.09-2.94.72-4.26 1.94-3.88 3.51.57 2.33 3.29 1.41 8.59 1.11 5.97-.34 9.32.93 10.33 5.08 1.25 5.16-2.32 9.23-10.29 11.17-3.63.88-6.46.97-7.95 1.34-.41.09-.79.28-1.15.53l-3.14-6.41c4.06.95 7.7 1 11.12.16z"
          id="path447"
        />
        <path
          className="st8"
          d="M425.01 186.36c-.01-.13-.03-.62-.06-1.37l-.67-16.11-1.2.05c-3.4.14-6.24.68-8.94 2.49.7-3.14 1.34-4.87 1.31-5.41-.01-.29-.19-.62-.45-.98l24.35-1.02c-.27.39-.39.72-.38 1.01.03.5.76 2.17 1.76 5.28-2.84-1.58-5.72-1.88-9.12-1.74l-1.28.05.67 16.11c.09 2.03 1.03 3.78 2.42 4.22l-10.27.43c1.22-.58 1.91-1.89 1.86-3.01z"
          id="path449"
        />
        <path
          className="st8"
          d="m440.56 184.51 2.93-15.95c.4-2.2.03-3.62-1.28-4.53l25.45 4.67c-.35.32-.53.62-.59.91-.09.49.26 2.28.55 5.54-2.42-2.18-5.21-3.11-8.51-3.71l-9.66-1.77-1.05 5.67 10.69 1.96c1.42.27 2.5.13 3.38-.05l-2.67 3.05c-.69.8-1.69 1.12-2.78.92l-9.38-1.72-1.11 6.11 10.19 1.87c4.04.74 7.45.31 9.99-1.16-1.98 3.22-3.27 4.96-3.38 5.57-.07.33.04.68.24 1.14l-25.81-4.73c1.55-.35 2.41-1.59 2.8-3.79z"
          id="path451"
        />
        <path
          className="st8"
          d="M484.2 187.43c3.54 1.72 5.38 1.73 6.54-.65 1.16-2.39-.01-3.78-3.56-5.5l-5.93-2.88-2.98 6.16zm-9.96 10.29-9.21-4.46c1.63.05 2.75-.92 3.74-2.98l7.04-14.51c.97-2.01.99-3.48-.03-4.71l13.09 6.34c2.87 1.39 5.15 2.49 6.53 3.81 2.18 2.07 2.72 5.14 1.29 8.09-1.52 3.13-4.78 4.45-9.07 3.3 1.49 1.78 1.85 3.52 2.1 5.57.35 2.8.31 5.45 1.71 7.88l-9.51-4.61c.66-.24 1.06-.5 1.3-.99.54-1.12.58-2.99-.05-5.59-.59-2.5-1.94-4.17-4.19-5.25l-2.57-1.24-2.2 4.55c-.99 2.05-1.01 3.61.03 4.8z"
          id="path453"
        />
        <path
          className="st8"
          d="M512.49 225.62c-1.31-1.28-4.02-2.78-6.76-5.49-6.26-6.17-6.63-12.99-1.05-18.66 5.65-5.74 13.42-5.41 19.99 1.07 3.02 2.97 4.42 5.74 5.57 6.88.3.29.68.49 1.15.78l-5.87 2.83c-.58-2.84-1.83-5.12-3.84-7.1-3.87-3.81-8.73-3.65-12.19-.14-3.81 3.87-3.78 7.97.14 11.84 2.22 2.18 5.01 3.6 8.57 4.77l-4.68 4.76c-.33-.67-.65-1.17-1.03-1.54z"
          id="path455"
        />
        <path
          className="st8"
          d="m535.99 224.24-13.15 9.19c-1.87 1.31-2.63 2.6-2.32 4.2l-5.87-8.39c1.39.84 2.85.53 4.72-.77l13.15-9.19c1.86-1.31 2.66-2.57 2.34-4.17l5.86 8.39c-1.39-.85-2.86-.57-4.73.74z"
          id="path457"
        />
        <path
          className="st8"
          d="M527.5 244.11c.11-.05.56-.27 1.24-.59l14.56-6.94-.52-1.09c-1.46-3.07-3.06-5.47-5.79-7.25 3.16-.59 5-.68 5.49-.92.26-.12.49-.42.72-.8l10.48 22.01c-.46-.1-.82-.07-1.07.06-.45.21-1.7 1.54-4.17 3.69.34-3.24-.52-6-1.99-9.07l-.54-1.16-14.57 6.94c-1.83.87-3.07 2.43-2.93 3.88l-4.42-9.29c1.02.89 2.5 1.01 3.51.53z"
          id="path459"
        />
        <path
          className="st8"
          d="M558.04 273.37c.65-.14 1.01-.47 1.32-1.17l2 9.62c-2.3-1.51-4.29-2.32-5.7-2.96l-13.05-6.13-3.77.78c-2.24.47-3.5 1.49-3.78 2.99l-2.1-10.07c1.06 1.43 2.45 1.61 4.64 1.16l3.65-.76 10.51-11.17c1.59-1.69 2.76-3.03 3.16-4.76l2.22 10.63c-.51-.61-.97-.78-1.62-.64-.92.2-1.42.72-2.07 1.41l-6.61 6.88 9.1 3.86c.79.35 1.49.46 2.1.33z"
          id="path461"
        />
        <path
          d="m487.03 252.93.32-.32.02-.59c.08-2.17.68-8.42 2.45-11.19 2.42-3.78 1.23-7.66.59-9.74-.1-.32-.18-.6-.25-.83-.48-1.96-1.44-3.72-1.48-3.79l-.59-1.09-1.18.38c-.78.25-18.94 6.23-28.27 19.8-1.17.92-2.39 1.87-3.49 2.71-.02-.21-.05-.41-.11-.62-.23-.91-.91-2.16-2.8-2.9-2.29-.9-10.47-3.24-20.65-3.24-8.16 0-15.6 1.48-22.11 4.4l-1.49.67.45.8c-8.95-7.67-25.85-21.56-30.7-21.56h-.18l-.67.04-.42.52c-.13.16-.8 1.05-1.45 3-.03.11-.13.21-.35.45-1.59 1.63-2.05 3.48-.08 9.04 2.74 7.76 2.93 10.75 3.05 12.73.16 2.49 2.13 8.23 2.92 9.84.38 1.59 3.07 12.55 4.37 15.59 1.15 2.68-.11 4.21-1.37 5.01l-.32.21c-1.59 1-4.9 3.08-5.35 6.56-.29 2.25.68 4.61 2.87 7.02.53 1 1.01 2.16 1.1 2.63 0 .01-.01.01-.01.01-.78 1.28.04 2.09.84 2.88l.48.48c.82.82 1.71 1.41 2.49 1.94.91.61 1.7 1.13 2.3 1.93.31.41.53.8.75 1.18.53.92 1.07 1.86 2.51 2.69l-.27 1.72c-.37 2.39.39 7.62 5.92 10.23 1.62.78 2.84 1.31 3.73 1.69 2.33 1.01 2.33 1.01 3.07 2.33 1.47 2.61 4.35 5.63 7.33 7.66 2.4 1.65 4.63 4.83 4.9 5.62l2.38.71.24-.03c.03-.03.17-.2.36-.5.08.05.15.11.22.16-.74 1.87-1.43 4.03-1.43 5.5 0 2.21.9 7.28 8.97 8.61l.04.07 2.17 1.5 2.69 2.31.36.22h1.92l.16-.05 1.95-.44.5-.11.33-.41 1.18-1.49 1.03-1.29c3.03-.24 4.89-1.63 5.92-2.4l.09-.07c1.57-1.18 3.43-5.63 3.43-6.57 0-.48-.29-2.58-.46-3.79l-.03-.16-.06-.14-.86-2.34c.57.94.7 1.33.7 1.33l.87 2.65 1.73-2.12 3.98-4.87c.36-.36 2.45-2.44 3.78-3.63 1.25-1.12 1.95-2.6 2.45-3.67.18-.38.35-.75.47-.92.53-.71 5.14-4.53 9-6.53 4.91-2.54 5.92-7.53 5.42-10.27l-.13-.65-.48-.29c.45-1.03.83-2.1 1.12-3.2 2.67-1.66 5.64-3.87 7.96-6.53l.6-.73-.35-.85c-.04-.11-1.01-2.59 1.86-6.06 2.5-3.01 3.1-4.28 2.57-5.39-.21-.46-.62-.79-1.1-.91-3.03-2.16-5.76-4.77-5.93-5.69-.05-.28-.11-.56-.16-.86-.46-2.17-.97-4.63.76-7.86 1.67-3.13 1.78-4.66 1.76-6.08-.01-.34-.01-.54.03-.72.52-2.38 2.48-10.09 3.12-11.33z"
          id="path463"
          style={{
            fill: "#fbba00",
          }}
        />
        <path
          className="st3"
          d="m440.76 327.25 1.32 4.11.6 5.58-3.63 2.74-13.12-.39-5.02-4.49 2.21-1.89 1.26-5.68c-16.42-12.32-23.68-13.58-23.68-13.58-3.27-1.5-6.74-2.26-9.72-2.63l-.05.29c-.37 2.39.39 7.62 5.92 10.23 1.62.78 2.84 1.31 3.73 1.69 2.34 1.01 2.34 1.01 3.08 2.33 1.47 2.61 4.35 5.63 7.33 7.66 2.4 1.65 4.63 4.83 4.9 5.62l2.38.71.24-.03c.03-.03.17-.2.36-.5.08.05.15.11.22.16-.74 1.87-1.43 4.03-1.43 5.5 0 2.21.9 7.28 8.97 8.61l.04.07 2.17 1.5 2.69 2.31.36.22h1.93l.16-.05 1.95-.44.5-.11.33-.41 1.19-1.49 1.03-1.29c3.03-.24 4.89-1.63 5.92-2.4l.09-.07c1.57-1.18 3.43-5.63 3.43-6.57 0-.48-.29-2.58-.46-3.79l-.03-.16-.06-.14-.86-2.34c.57.94.7 1.33.7 1.33l.87 2.65 1.73-2.12 3.98-4.87c.36-.36 2.44-2.44 3.78-3.63 1.25-1.12 1.95-2.6 2.45-3.67.18-.38.35-.75.47-.92.52-.71 5.14-4.53 9-6.53 4.91-2.54 5.92-7.53 5.42-10.27l-.5-1.94.08-.4-4.56 2.5c-29.82 11.41-29.67 16.99-29.67 16.99z"
          id="path465"
        />
        <path
          className="st8"
          d="M401.87 294.33s.9-1.2 3.14.59 7.3 5.83 12.38 5.23c0 0 1.05 1.65-2.54 1.5-3.59-.15-3.43-.3-4.63-.45-1.19-.15-6.26-4.93-6.71-5.68-.44-.75-1.64-1.19-1.64-1.19z"
          id="path467"
        />
        <path
          className="st8"
          d="m435.27 259.73-1.65-1.34s-.9-2.69-.45-3.88 6.72-5.08 7.91-5.67c0 0-1.79 3.28-3.44 4.33-1.64 1.05-2.54 2.69-2.54 2.69s-.43 2.38.17 3.87z"
          id="path469"
        />
        <path
          className="st8"
          d="M430.04 259.29s1.93-3.28.9-4.18c-1.05-.9-7.47-5.82-7.47-5.82s.15 3.13 1.64 4.18c1.49 1.05 2.83 1.05 2.98 1.79l.15.75s-.3.74.3 1.49c.6.74 1.5 1.79 1.5 1.79z"
          id="path471"
        />
        <path
          className="st8"
          d="M446.46 277.91s7.72-4.07 10.37-4.68c2.64-.61 0-1.22-.61-1.43-.61-.2-2.44-.2-2.44-.2l-2.45 1.02-1.21.61-1.83 1.43-1.43.61-.81.4s-.82 2.85.41 2.24z"
          id="path473"
        />
        <path
          className="st8"
          d="M407.61 272.42c-.22-1.01 1.02.41 1.83.81.82.41 4.68 1.63 4.68 1.63l1.23.81 2.03 1.63-.41 1.02s-1.22 0-1.83-.62c-.61-.61-2.58-1.95-2.72-1.59-.13.37-1.35-.04-2.37-.65-1.02-.6-2.04-1.21-2.44-3.04z"
          id="path475"
        />
        <path
          className="st3"
          d="M399.64 256.54c-.29-.61-.68-1.49-.77-1.88-.05-.2-.11-.39-.18-.61-.2-.63-.47-1.49-.76-4.14-.34-3.13-2.11-4.99-3.05-5.99-.15-.16-.36-.38-.43-.47-.45-.87-1.16-1.03-1.55-1.11-.37-.08-1.15-.25-3.02-2.03-3.37-3.22-7.35-5.83-7.51-5.94l-3.46-2.26 1.32 3.95c.55 1.64 1.15 3.7 1.19 4.12 0 .42.09 1.28.25 2.78.15 1.33.33 2.98.33 3.55 0 1.24.83 6.67.99 7.74l.03.23.1.2c.28.54 1.65 3.32 2.29 4.17l.14.19c.42.57.52.7.79 1.51-.02.06-.05.14-.07.22-.37 1.09-.68 2.5.28 5.56.8 2.52 2.18 3.05 3.22 3.05 1.8 0 3.23-1.75 3.57-2.19.28-.34 1.02-1.22 1.45-1.66.12-.12.28-.29.48-.51.76-.81 2.18-2.32 3.69-3.54 1.23-.99 1.5-2.04 1.52-2.74.02-1.04-.51-1.81-.84-2.2z"
          id="path477"
        />
        <path
          className="st8"
          d="M460.83 292.24s-.85.15-.85 1.34c0 1.19-4.81 5.18-6.36 5.92-1.55.74-3.39.46-5.09.46-1.69 0-2.26 2.22-2.26 2.22.01.01.01.01.03.01-.56.95-1.19 2.69-1.19 2.69s-.58 4.24-1.93 8.49c-1.35 4.24.77 9.69.96 10.51.18.8 1.73 3.43 2.3 4.23.59.82.67 4.12.67 4.12l1.08-3.92s-.19-1.41-.38-2.22c-.2-.81-1.36-1.82-1.74-3.23-.38-1.42-1.35-5.25-1.35-6.27 0-1.01.97-6.66 1.16-7.67.19-1.01 1.14-3.03 1.25-5.89.01-.33.01-.58 0-.79 8.87.46 13.01-5.13 13.71-5.99.71-.89 1.55-4 1.55-4h-1.56z"
          id="path479"
        />
        <path
          className="st3"
          d="M481.7 233.89c-1.58 1.69-3.73 2.95-6 4.3-4.17 2.46-8.9 5.25-9.3 11.15l-.03.5.29.42c.97 1.39.43 2.42-.67 4.27-.57.94-1.16 1.93-1.42 3.05l-.22.92.76.58c1.1.84 2.09 1.95 3.03 3.02 1.97 2.21 4 4.48 7.35 4.87l.86.1.5-.69c1.74-2.37 2.22-5.08 2.68-7.71.42-2.39.82-4.66 2.16-6.48l.36-.5-.1-.6c-.44-2.66.34-6.01 1.09-9.25.53-2.32 1.09-4.71 1.2-6.89l.21-4.04z"
          id="path481"
        />
        <path
          className="st8"
          d="M418.4 304.28c.53 6.39 6.28 11.22 2.48 17.53.47 3.59-2.95 5.38-3.9 8.34-1.53 0-.82-2.44-.59-3.46 3.31-5.76 4.37-13.83.83-19.98-.12-1.03.11-2.17 1.18-2.43"
          id="path483"
        />
        <path
          className="st8"
          d="M480.62 250.9c-3.14 4.29-1.78 10.28-4.92 14.57-4.38-.51-6.28-5.07-9.82-7.81.67-2.86 4.22-5.33 1.91-8.72.55-8.2 10.24-9.63 15.15-14.96-.28 5.21-3.15 11.84-2.32 16.92zm3.54-20.95c-5.45 4.69-12.28 6.37-17.33 12.1-5.04 4.43.82 11.85-6.14 15.35 4.91 4.56 9.27 9.5 15.28 12.75 4.23-2.6 4.36-7.41 4.63-11.84 4.37-7.68 2.19-16.79 5.59-24.99-.67-1.15.15-3.89-2.03-3.37z"
          id="path485"
        />
        <path
          className="st8"
          d="M398.25 260.69c-2.03 1.62-3.86 3.66-4.47 4.27-.61.61-1.63 1.83-1.63 1.83s-3.05 4.07-4.47-.41c-1.43-4.47.2-4.68-.2-5.9-.41-1.22-.61-1.43-1.23-2.24-.61-.81-2.24-4.07-2.24-4.07s-1.01-6.51-1.01-7.73c0-1.22-.61-5.7-.61-6.51 0-.82-1.32-4.72-1.32-4.72s4.17 2.69 7.63 5.94c3.46 3.25 4.07 2.03 4.47 2.84.41.81 3.05 2.44 3.46 6.1.41 3.66.82 4.27 1.02 5.08.21.82 1.02 2.44 1.02 2.44s1.61 1.45-.42 3.08zm2.24-5.29c-.41-1.01-1.43-.2-1.03-3.01.9-6.54.21-3.51-3.24-9.19 0 0-2.24-2.65-2.35-3.36-.13-.71-.69-.3-1.71-.91-1.01-.61-1.63-.82-3.05-1.63-1.42-.81-1.83-1.42-3.66-3.25s-4.68-2.85-5.7-3.46c-1.02-.61-1.62 0-1.62 0-1.02 0 .41 4.27.41 5.09 0 .81.4 4.88 1.42 10.37 1.02 5.49 2.24 10.37 3.05 12.2.81 1.83 1.01 3.26 1.63 7.93.61 4.68 3.78 6.14 3.78 6.14s5.58-5.32 7.81-6.54c2.24-1.22 2.85-2.65 4.07-4.27 1.22-1.63 1.22-1.63 2.24-3.26 1-1.63-1.64-1.83-2.05-2.85z"
          id="path487"
        />
        <path
          className="st8"
          d="M417.06 295.54a3.43 3.43 0 1 1-6.862.002 3.43 3.43 0 0 1 6.862-.002z"
          id="path489"
        />
        <path
          className="st3"
          d="M412.91 294.28c0 .4-.32.72-.72.72a.72.72 0 1 1 0-1.44c.39 0 .72.32.72.72z"
          id="path491"
        />
        <path
          className="st8"
          d="M455.05 295.54c0 1.89-1.54 3.43-3.43 3.43-1.89 0-3.43-1.54-3.43-3.43 0-1.89 1.54-3.43 3.43-3.43 1.89 0 3.43 1.54 3.43 3.43z"
          id="path493"
        />
        <path
          className="st8"
          d="M406.08 289.63c-3.26.11-7.08.68-10.22.32 1.66.78 4.95 1.59 10.08 1.77 2.08-.46 3.93-.76 6.24-.45 5.54.67 8.08 6.47 12.4 8.63l.68-2.16c-3.37-6.77-11.75-10.96-19.18-8.11z"
          id="path495"
        />
        <path
          className="st8"
          d="M484.83 290.79c-3.58 4.33-2.08 7.61-2.08 7.61-5.08 5.82-13.45 9.4-14.04 9.55-.59.15-1.64 1.35-2.24 1.95-.6.6-3.73 4.18-3.73 4.18l1.49.15-.54 1.9s2.18-2.5 2.93-3.55c.75-1.04 2.68-.45 2.68-.45l2.1-1.04s.9-.59 1.35-.89c.45-.3 1.19.15 1.19.15.45 2.38-.59 6.57-4.63 8.66-4.02 2.09-8.96 6.12-9.55 7.02-.59.89-1.19 2.99-2.69 4.33-1.49 1.34-3.88 3.74-3.88 3.74l-4.03 4.93s-.15-.6-1.2-2.25c-1.05-1.63-.45-1.49-.6-2.38-.15-.9-.45-1.65-1.2-2.99-.73-1.33-1.64-.59-2.24-1.04-.59-.45-1.04-1.79-1.04-3.28 0-1.5-3.58-18.52-3.88-20.01l-.3-1.49s1.79-4.18 6.27-9.41c1-1.16 2.01-2.03 2.99-2.67 0 .02 0 .04-.01.06 1.67-1.11 4.5-2.37 7.85-1.32-.01-.02-.02-.03-.03-.05 1.88.53 3.54.78 5.01.83 5.49-.53 7.75-2.61 8.62-3.89-2.3.51-6.81 1-6.81 1-21.8-1.94-16.42.96-16.42.96-4.78 1.64-7.01 8.06-7.01 8.06s-1.5 1.94-2.09 2.83c-.59.91-.59 4.49-.45 5.38.15.89.45 3.29.45 3.29-1.63 7.31 2.99 18.66 3.14 19.1.15.46 1.59 7 1.59 7l.82.2 1.18-1.24h.74l.31.75 1.63 4.47s.45 3.14.45 3.59c0 .44-1.64 4.48-2.83 5.37-1.2.89-3.44 2.69-7.62 2.09-.12-.01-.24-.03-.36-.04-.82-.19-1.65-.36-1.65-.36l-.81-.2-.61-.61-.2-.82v-1.46c1.48-.24 2.59-.99 2.59-.99 3.88-1.78 4.48-5.25 4.48-7.53 0-1.11-1.8-2.03-1.8-2.03-4.93-1.49-9.26-.75-11.79-.15-2.54.6-1.64 4.18-1.64 4.18-.06 2.14 4.18 5.53 4.18 5.53.98.77 2.01 1.05 2.97 1.06v.78s-.2.81-.61 1.63c-.27.55-1.48.8-2.26.93-.44.05-.69.08-.69.08-7.61-.75-9.1-4.63-9.1-7.31 0-2.69 2.98-8.66 2.98-8.66l.9.75s1.64 0 2.09-.29c.45-.31.3-1.05 0-1.5-.3-.44-.75-1.34-.75-1.34 3.43-3.58 5.53-27.32 5.68-27.92.14-.6-.15-1.65-.15-1.65l-.45-1.05-.9-.89s-1.94-1.5-2.84-1.04c-.9.44.89 2.83.89 2.83l1.05 1.35c-1.05 1.49-1.94 9.7-1.94 9.7l-1.64 10.3s-1.34 2.99-1.94 5.82c-.6 2.84-3.28.74-3.28.74.89 3.88-1.49 6.72-1.49 6.72-.15-.9-2.69-4.63-5.53-6.57-2.83-1.93-5.52-4.78-6.87-7.16-1.34-2.39-1.49-1.8-7.47-4.63-5.97-2.84-5.08-8.66-5.08-8.66s4.18 1.64 4.78 1.79c.59.15 3.44 1.05 4.48 1.5 1.05.45 5.53 3.28 1.05-1.65s-6.72-3.28-9.55-4.33c-2.84-1.05-2.69-2.24-4.03-4.03-1.34-1.8-3.28-2.39-4.93-4.03-1.64-1.64-1.19-1.05-.89-1.95.3-.89-1.34-3.88-1.34-3.88-6.27-6.72.3-10.3 2.39-11.64 2.09-1.35 3.28-3.74 1.94-6.87-1.34-3.13-4.33-15.53-4.33-15.53-.6-1.05-2.69-7.02-2.83-9.41-.15-2.39-.45-5.52-3.14-13.14-2.69-7.61-.15-6.71.45-8.51.6-1.79 1.19-2.54 1.19-2.54 5.53-.3 34.64 25.38 34.64 25.38-.48-1.88-1.23-3.69-2.19-5.43 17.61-7.9 37.58-2.72 41.6-1.14 4.19 1.65.45 6.13.45 6.13.59-.15 7.62-5.67 7.62-5.67 9.11-13.44 27.62-19.41 27.62-19.41s.9 1.64 1.35 3.44c.45 1.79 2.24 5.67-.15 9.4-2.39 3.73-2.69 11.95-2.69 11.95-.75.75-3.13 10.6-3.43 11.94-.31 1.34.6 2.24-1.65 6.42-2.24 4.18-1.2 7.32-.75 9.7.45 2.39 6.87 6.87 6.87 6.87s1.45-.44-2.14 3.9zm-49.27 64.64-1.94.45h-1.34l-2.99-1.79s1.05-.3 3.13-.3c2.1 0 3.74.15 4.18.15h.15zm51.06-73.75c-6.42-4.77-2.55-8.66-1.2-11.35 1.35-2.69 1.94-7.76 1.94-9.1 0-1.35.3-6.57 1.94-8.06 1.65-1.49 1.95-9.55 2.69-11.5.74-1.94 1.04-5.08 1.04-5.82 0-.75.15-2.24.3-3.58.14-1.35-4.92-11.05-4.92-11.05-7.17.75-25.39 16.43-27.18 18.36-1.79 1.94-3.73 3.14-3.73 3.14-10.15-2.99-15.68-2.24-25.68-2.84-8.4-.5-20.59 2.58-24.28 3.58-10-12.97-30.66-20.9-30.66-20.9-7.61 7.61-2.24 25.83-1.49 27.47.75 1.64 2.54 4.63 2.39 7.91-.15 3.29 2.24 10.9 2.68 13.74.45 2.84 2.99 7.02 2.99 7.02s-1.64 1.79-4.48 4.63c-2.83 2.83-1.79 1.49-3.43 2.24-1.64.75-1.94 2.84-1.94 2.84s2.24 4.03 4.18 6.12c1.94 2.09-.6 3.88-.6 3.88s3.43 2.84 5.52 4.48c2.09 1.64.9 1.49 2.39 2.84 1.49 1.34.45 2.38.45 2.38l1.19 1.05c.89 10.6 10.15 14.48 13.59 16.41 3.43 1.95 5.82 5.09 5.82 5.09l2.84 2.24c7.16 5.08 7.16 9.7 7.16 9.7-1.35 8.06 4.33 9.55 4.33 9.55 7.61 2.54 7.16 3.13 7.16 3.13 5.82 4.63 7.46 2.24 9.55 1.65 2.1-.6 4.63-2.39 4.63-2.39 10.9-4.48 9.11-13.73 9.11-13.73s1.79-2.54 3.14-3.89 2.54-4.03 2.54-4.03 7.61-6.87 12.25-9.41c4.62-2.54 8.66-5.83 10.74-14.78 2.1-8.96 8.96-10.75 8.96-10.75-.6-1.04-1.34-3.43.3-5.82 1.64-2.38 4.31-6.1 4.33-6.12-.01.03-.4.25-6.56-4.33z"
          id="path497"
        />
        <path
          className="st3"
          d="M450.88 294.28c0 .4-.33.72-.73.72-.4 0-.71-.32-.71-.72 0-.4.31-.72.71-.72.41 0 .73.32.73.72z"
          id="path499"
        />
      </g>
    </g>
  </svg>
));
